import { IOffersData } from 'shared/offer';
import { ICommercialBreadcrumbs } from 'shared/types/commercialBreadcrumbs';
import { IDeveloperInfo, IDeveloperInfoRedesigned } from 'shared/types/developerInfo';
import { IOldQuickLinks, IQuickLinksTab } from 'shared/types/quickLinks';
import { IRecommendedVillages } from 'shared/types/recommendedVillages';
import { IResidentialComplexInfo } from 'shared/types/residentialComplexInfo';
import { INewbuildingLayout } from 'shared/types/residentialComplexLayouts/layouts/newbuildingLayout';
import { ISimilarNewobject, ISimilarNewobjectFromDeveloper } from 'shared/types/similarNewobjects';
import { ISuburbanProjectSuggest } from 'shared/types/suburbanBuildersProjects';
import { IVillageInfo } from 'shared/types/villageInfo';

export const FILTERS_SEARCH_SEARCH_REQUEST_START_REQUESTED = 'filters/search/SEARCH_REQUEST_START_REQUESTED';
export const FILTERS_SEARCH_SEARCH_REQUEST_FETCHING = 'filters/search/SEARCH_REQUEST_FETCHING';
export const FILTERS_SEARCH_SEARCH_REQUEST_FINISHED = 'filters/search/SEARCH_REQUEST_FINISHED';
export const FILTERS_SEARCH_SEARCH_REQUEST_CANCELLED = 'filters/search/SEARCH_REQUEST_CANCELLED';

export interface ISearchRequestStartRequestedAction {
  type: 'filters/search/SEARCH_REQUEST_START_REQUESTED';
}

export interface ISearchRequestFetchingAction {
  type: 'filters/search/SEARCH_REQUEST_FETCHING';
}

export interface ISearchRequestCancelledAction {
  type: 'filters/search/SEARCH_REQUEST_CANCELLED';
}

export interface ISearchSaveTooltipHidderAction {
  type: 'filters/save_tooltip/TOOLTIP_HIDDEN';
}

export interface ISearchRequestFinishedAction {
  type: 'filters/search/SEARCH_REQUEST_FINISHED';
  data: IOffersData;
  newbuildingInfo: IResidentialComplexInfo | null;
  developerInfo: IDeveloperInfo | null;
  developerInfoRedesigned: IDeveloperInfoRedesigned | null;
  villageInfo: IVillageInfo | null;
  similarNewobjects: ISimilarNewobject[] | null;
  similarNewobjectsFromDeveloper: ISimilarNewobjectFromDeveloper[] | null;
  quickLinks: IQuickLinksTab[] | null;
  oldQuickLinks: IOldQuickLinks | null;
  recommendedVillages: IRecommendedVillages | null;
  suburbanBuildersProjects: ISuburbanProjectSuggest[];
  newbuildingLayouts: INewbuildingLayout[] | null;
  commercialBreadcrumbs: ICommercialBreadcrumbs | null;
}
